<h1 class="sr-only"> PHI - DOCTOR - Ρυθμίσεις Λογαριασμού </h1>
<div class="grid">
  <div class="col-12">
    <div class="card p-4 flex flex-column h-full">
      <div class="text-2xl text-primary font-bold mb-3 flex align-items-center">
        <span class="p-badge text-white p-badge-no-gutter p-badge-lg mr-2"
          ><i class="pi pi-cog"></i
        ></span>
        Ρυθμίσεις Λογαριασμού
      </div>
      <hr class="my-3 mx-0 border-top-1 border-none surface-border" />
      <div
        class="flex flex-row justify-content-start align-items-center flex-wrap gap-5"
      >
        <h2 class="text-900 font-bold text-lg text-center p-0 m-0">Συγχρονισμός ημερολογίου</h2>
        <div class="flex flex-row align-items-center gap-3">
          <img
            src="/assets/images/google-calendar-48x48.png"
            alt="Google Calendar"
          />
          @if(syncedCalendar['google']==false){
          <span class="font-bold text-lg">Google Calendar</span>
          <button
            type="button"
            class="pi pi-sync font-bold cursor-pointer p-link"
            style="background: none; border: none;"
            aria-label="Συγχρονισμός Google Calendar"
            (click)="syncCalendar('google')"
          ></button>
          }@else{
          <span class="font-bold text-lg">Synced</span>
          }
        </div>
        <!-- <div class="flex flex-row align-items-center gap-3">
        <img src="/assets/images/yahoo-calendar-48x48.png" alt="" srcset="" />
        @if(syncedCalendar['yahoo']==false){
        <span class="font-bold text-lg">Yahoo Calendar</span>
        <i
          class="pi pi-sync font-bold cursor-pointer"
          (click)="syncCalendar('yahoo')"
        ></i>
        }@else{
        <span class="font-bold text-lg">Synced</span>
        }
      </div>
      <div class="flex flex-row align-items-center gap-3">
        <img
          src="/assets/images/microsoft-calendar-48x48.png"
          alt=""
          srcset=""
        />@if(syncedCalendar['microsoft']==false){
        <span class="font-bold text-lg">Microsoft Calendar</span>
        <i
          class="pi pi-sync font-bold cursor-pointer"
          (click)="syncCalendar('microsoft')"
        ></i>
        }@else{
        <span class="font-bold text-lg">Synced</span>
        }
      </div>
      <div class="flex flex-row align-items-center gap-3">
        <img
          src="/assets/images/apple-calendar-48x48.png"
          alt=""
          srcset=""
        />@if(syncedCalendar['apple']==false){
        <span class="font-bold text-lg">Apple Calendar</span>
        <i
          class="pi pi-sync font-bold cursor-pointer"
          (click)="syncCalendar('apple')"
        ></i>
        }@else{
        <span class="font-bold text-lg">Synced</span>
        }
      </div> -->
      </div>
    </div>
  </div>
  <div class="col-12">
    <lib-personal-info [userData]="userData | async"></lib-personal-info>
  </div>
</div>
